import { AccountService } from '../node_modules/services/service/account_service.js';
import { AppService } from '../node_modules/services/service/app_service.js';
import { LocationService } from '../node_modules/services/service/location_service.js';
import { ProfileService } from '../node_modules/services/service/profile_service.js';
import { TripService } from '../node_modules/services/service/trip_service.js';
import { WeatherService } from '../node_modules/services/service/weather_service.js';

import { error } from './logger.js';

class Services {
  get account() {
    if (!this.#account) {
      this.#account = new AccountService(this.#request, error);
    }
    return this.#account;
  }

  get app() {
    if (!this.#app) {
      this.#app = new AppService(this.#request, error);
    }
    return this.#app;
  }

  get location() {
    if (!this.#location) {
      this.#location = new LocationService(this.#request, error);
    }
    return this.#location;
  }

  get profile() {
    if (!this.#profile) {
      this.#profile = new ProfileService(this.#request, error);
    }
    return this.#profile;
  }

  get trip() {
    if (!this.#trip) {
      this.#trip = new TripService(this.#request, error);
    }
    return this.#trip;
  }

  get weather() {
    if (!this.#weather) {
      this.#weather = new WeatherService(this.#request, error);
    }
    return this.#weather;
  }

  get request() {
    return this.#request;
  }

  setRequest(request) {
    this.#request = request;

    this.#location = null;
    this.#profile = null;
    this.#trip = null;
    this.#weather = null;
  }

  #account;
  #app;
  #location;
  #profile;
  #trip;
  #weather;

  #request;
}

const services = new Services();

export { services };
